import { Col, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { Store } from 'antd/lib/form/interface';
import Modal from 'antd/lib/modal/Modal';
import React, { useContext, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import AuthWrapper from 'components/base/AuthWrapper';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';

import pxKlicSms from 'services/pxKlicSms';

import routePathEnum from 'enums/routePathEnum';

interface IPxKlicLogin {}

const PxKlicLogin: React.FC<IPxKlicLogin> = () => {
    const [form] = useForm();
    const { language } = useContext(Context);
    const { navigateWorkaround } = useNavigateWorkaround();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [errMessage, setErrMessage] = useState<string>('');
    const [isFirstPage, setIsFirstPage] = useState<boolean>(true);
    const [phone, setPhone] = useState<string>('');

    const onFinish = (value: Store) => {
        setLoading(true);
        pxKlicSms(value.username, value.password, language)
            .then(data => setPhone(data.mobil))
            .catch(() => setErrMessage('RESPONSE_ERROR_400'))
            .finally(() => setLoading(false));
    };
    return (
        <AuthWrapper>
            {isFirstPage ? (
                <LoadingWrapper loading={loading}>
                    <Title text="PXKLIC_TITLE" level={5} />
                    <Paragraph
                        style={{
                            display: 'block'
                        }}
                        text="PXKLIC_TEXT1"
                    />
                    <Paragraph
                        style={{
                            display: 'block'
                        }}
                        text="PXKLIC_TEXT2"
                    />
                    <Paragraph
                        style={{
                            display: 'block'
                        }}
                        text="PXKLIC_TEXT3"
                    />
                    <Col>
                        <Row className="button-row">
                            <ButtonComponent
                                buttontext="ZPET"
                                onClick={() => navigateWorkaround(routePathEnum.LOGIN_ROZCESTNIK)}
                                id="pxKlicZpetRedirectBtn"
                                type="default"
                            />
                            <ButtonComponent
                                buttontext="POKRACOVAT"
                                onClick={() => setShowModal(true)}
                                id="pxKlicPokracovatBtn"
                            />
                        </Row>
                    </Col>

                    <Modal
                        open={showModal}
                        onCancel={() => setShowModal(false)}
                        footer={
                            <Row className="button-row-modal">
                                <ButtonComponent
                                    buttontext="ZAVRIT"
                                    id="pxKlicModalZpetBtn"
                                    type="default"
                                    onClick={() => {
                                        setShowModal(false);
                                    }}
                                />
                                <ButtonComponent
                                    id="pxKlicModalPokracovatBtn"
                                    buttontext="POKRACOVAT"
                                    onClick={() => {
                                        setShowModal(false);
                                        setIsFirstPage(false);
                                    }}
                                />
                            </Row>
                        }
                        title={<TranslateText>PXKLIC</TranslateText>}
                    >
                        <Row>
                            <Paragraph text="PXKLIC_ODELSAT_CONFIRM" />
                        </Row>
                    </Modal>
                </LoadingWrapper>
            ) : (
                <>
                    {!phone && (
                        <>
                            <Title text="EMP_INFO_ZMENA_LOGIN_ZADEJTE" level={5} />
                            <FormWrapper onFinish={onFinish} outForm={form}>
                                <InputComponent label="UZIVATELSKE_JMENO" name="username" />
                                <InputComponent label="HESLO" name="password" type={'password'} />
                                <Row className="button-row">
                                    <ButtonComponent
                                        buttontext="ZPET"
                                        onClick={() => setIsFirstPage(true)}
                                        type="default"
                                        id="pxKlicZpetBtn"
                                    />
                                    <ButtonComponent
                                        buttontext="POKRACOVAT"
                                        id="pxKlicPokracovatBtn"
                                        onClick={() => form.submit()}
                                        loading={loading}
                                    />

                                    {errMessage && <TranslateText>{errMessage}</TranslateText>}
                                </Row>
                            </FormWrapper>
                        </>
                    )}
                    {phone && (
                        <>
                            <Paragraph text="PXKLIC_SMS_ODESLAN" />
                            <Paragraph text={` ${phone}`} />
                            <Col
                                style={{
                                    marginTop: 26
                                }}
                            >
                                <ButtonComponent
                                    id="pxKlicPhonePokracovatBtn"
                                    buttontext="POKRACOVAT"
                                    onClick={() => navigateWorkaround(routePathEnum.LOGIN_ROZCESTNIK)}
                                />
                            </Col>
                        </>
                    )}
                </>
            )}
        </AuthWrapper>
    );
};

export default PxKlicLogin;
